export const ENACO_LANDING_PAGE_LINK = 'https://www.enaco.fr/';
export const ENACO_FACEBOOK_LINK = 'https://www.facebook.com/ecole.enaco/';
export const ENACO_LINKEDIN_LINK =
  'https://www.linkedin.com/school/enaco-ecole-nationale-de-commerce/mycompany/';
export const ENACO_X_LINK = 'https://x.com/GroupeEnaco';
export const ANDROID_STORE_LINK =
  'https://play.google.com/store/apps/details?id=fr.enaco.didaskill';
export const APPLE_STORE_LINK = 'https://apps.apple.com/fr/app/id6463633769';
